import './mlpReview.scss';

const SELECTOR_BUTTON_PREV = '.js-mlpReviewLeft';
const SELECTOR_BUTTON_NEXT = '.js-mlpReviewRight';
const SELECTOR_REVIEW = '.js-mlp-review';
const SELECTOR_REVIEWS = '.js-mlp-review-images';

const changeCurrent = function changeCurrentReviewImage(props = {}) {
  const { delta, el } = props;

  const current = (el.getAttribute('data-current') || 0) * 1;
  const next = current + delta;
  const items = el.querySelectorAll(SELECTOR_REVIEW);
  const count = items.length;

  if (next < 0 || next >= count) {
    return;
  }

  el.setAttribute('data-current', next);
  [].forEach.call(
    items,
    (item, index) => {
      item.classList[index === next ? 'add' : 'remove']('is-current');
    },
  );

};


const onPrevClick = function onNextReviewImageClick(ev) {
  const el = ev.currentTarget.closest(SELECTOR_REVIEWS);
  ev.stopPropagation();

  changeCurrent({
    el,
    delta: -1,
  });
};

const onNextClick = function onPrevReviewImageClick(ev) {

  const el = ev.currentTarget.closest(SELECTOR_REVIEWS);
  ev.stopPropagation();

  changeCurrent({
    el,
    delta: 1,
  });
};

const bind = function bindReviewImages() {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_BUTTON_PREV),
    (el) => {
      el.addEventListener('click', onPrevClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_BUTTON_NEXT),
    (el) => {
      el.addEventListener('click', onNextClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_REVIEW),
    (el) => {
      el.addEventListener('click', onNextClick);
    },
  );
};

const init = function initTestimonials() {
  bind();

  [].forEach.call(
    document.querySelectorAll(SELECTOR_REVIEWS),
    (el) => {
      changeCurrent({ el, delta: 0 });
    },
  );
};

const destroy = function destroyReviewImages() {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_BUTTON_PREV),
    (el) => {
      el.removeEventListener('click', onPrevClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_BUTTON_NEXT),
    (el) => {
      el.removeEventListener('click', onNextClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_REVIEW),
    (el) => {
      el.removeEventListener('click', onNextClick);
    },
  );
};

export default {
  destroy,
  init,
};
